import React, { FC } from 'react'
import { ICardProps, Card } from '../Card/Card'
import { EmptyCardList } from '../EmptyCardList/EmptyCardList'

export interface ICardListProps {
  cardPropsList: ICardProps[]
  emptyContent: React.ReactNode
  disableEdit?: boolean
  hideEdit?: boolean
}

export const CardList: FC<ICardListProps> = ({
  cardPropsList,
  emptyContent,
  disableEdit,
  hideEdit
}) => {
  if (cardPropsList.length === 0) {
    return <EmptyCardList>{emptyContent}</EmptyCardList>
  }
  return (
    <>
      {cardPropsList.map((cardProps) => (
        <div key={cardProps.title} className="my-u-pb--8">
          <Card
            disableEdit={disableEdit}
            {...cardProps}
            buttonCallbackOrHref={
              hideEdit ? undefined : cardProps.buttonCallbackOrHref
            }
          />
        </div>
      ))}
    </>
  )
}
